import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { TemplateRenderer } from '../templates/TemplateRenderer';
import type { InvitationData } from '../templates/types';
import { ArrowLeft, Sparkles } from 'lucide-react';

export function TemplateDirectPreviewPage() {
  const { templateId = 'video-02-kirtan-divine' } = useParams<{ templateId: string }>();

  const isKirtan = templateId === 'video-02-kirtan-divine';
  const isRoyal = templateId === 'video-01-royal-gold';
  const isRadha = templateId === 'video-03-radha-krishna';
  const isGsapRadha = templateId === 'exp-gsap-radha-krishna';
  const isGsapShiva = templateId === 'exp-gsap-shiva-parvati';
  const isGsap = isGsapRadha || isGsapShiva;

  const mockData: InvitationData = {
    templateId,
    occasionType: 'WEDDING',
    eventName: isKirtan || isRadha || isGsap ? 'Raghav & Riya' : isRoyal ? 'Aarav & Ananya' : 'Shubh Vivah',
    eventDate: '2025-10-28T18:00:00.000Z',
    eventVenue: isRadha || isGsap ? 'Vrindavan Garden Banquets, Pune' : 'Hallmark Banquets, Anand Vihar, Delhi - 110092',
    hostName: 'Mrs. Mansi Chopra & Mr. Lalit Chopra',
    mediaUrls: isGsapRadha
      ? [
          '/assets/templates/video-03-radha-krishna/royal-couple.webp',
          '/assets/templates/video-03-radha-krishna/blue-couple.webp',
          '/assets/templates/video-03-radha-krishna/green-couple.webp',
          '/assets/templates/video-03-radha-krishna/yellow-couple.webp',
          '/assets/templates/video-03-radha-krishna/haldi-procession.webp',
          '/assets/templates/video-03-radha-krishna/radha-krishna-garden.webp',
        ]
      : isGsapShiva
      ? [
          '/assets/templates/exp-shiva-parvati/shiva_parvati_hero_bg.jpg',
          '/assets/templates/exp-shiva-parvati/shiva_blessing_bg.jpg',
          '/assets/templates/exp-shiva-parvati/kailash_mandap_bg.jpg',
        ]
      : undefined,
    customData: {
      wedding: {
        groom: {
          fullName: isKirtan || isRadha || isGsap ? 'Raghav Chopra' : 'Aarav Sharma',
          nickname: isKirtan || isRadha || isGsap ? 'Raghav' : 'Aarav',
          photoUrl: isGsapRadha
            ? '/assets/templates/video-03-radha-krishna/royal-couple.webp'
            : isGsapShiva
            ? '/assets/templates/exp-shiva-parvati/shiva_blessing_bg.jpg'
            : undefined,
        },
        bride: {
          fullName: isKirtan || isRadha || isGsap ? 'Riya Kapoor' : 'Ananya Mehta',
          nickname: isKirtan || isRadha || isGsap ? 'Riya' : 'Ananya',
          photoUrl: isGsapRadha
            ? '/assets/templates/video-03-radha-krishna/blue-couple.webp'
            : isGsapShiva
            ? '/assets/templates/exp-shiva-parvati/kailash_mandap_bg.jpg'
            : undefined,
        },
      },
      ...(isRadha || isGsap
        ? {
            venueAddress: 'Vrindavan Garden Banquets, Pune',
          }
        : {}),
      experience: {
        version: '1.0',
        template: 'royal',
        plan: 'basic',
        rituals: [],
        meta: {
          groomName: isKirtan || isRadha || isGsap ? 'Raghav' : 'Aarav',
          brideName: isKirtan || isRadha || isGsap ? 'Riya' : 'Ananya',
          weddingDate: 'Tuesday, 28th October 2025',
          eventTime: '06:00 PM onwards',
          hostName: 'Chopra and Kapoor Families',
          tagline: isRadha || isGsap ? 'Two hearts meet under the grace of Radha Krishna.' : undefined,
          referenceImages: {},
        },
      } as any,
    },
  };

  return (
    <div className="relative min-h-screen bg-black text-white">
      {/* Floating Header Banner for direct preview navigation */}
      <div className="fixed top-3 left-3 z-50 flex items-center gap-2">
        <Link
          to="/wizard"
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/80 border border-amber-500/50 text-amber-300 text-xs font-semibold backdrop-blur-md shadow-lg hover:bg-amber-500/20 transition-all"
        >
          <ArrowLeft className="w-3.5 h-3.5" /> Back to Wizard
        </Link>
        <div className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-amber-500/20 border border-amber-400/40 text-amber-300 text-xs font-semibold backdrop-blur-md">
          <Sparkles className="w-3.5 h-3.5 text-amber-400" /> Previewing {templateId}
        </div>
      </div>

      <TemplateRenderer templateId={templateId} data={mockData} />
    </div>
  );
}
